import React from "react";
import { MailIcon, MessageCircleIcon } from "lucide-react";
import { ContactForm } from "./ContactForm";
import { contactInfo } from "../data/content";
export function Contact() {
  return <section id="contacto" className="scroll-mt-20 bg-paper text-ink" data-id="element-31" data-mp="3161su074utg0">
      <div className="mx-auto grid max-w-7xl gap-14 px-6 py-24 lg:grid-cols-[1fr_1.4fr] lg:gap-20 lg:px-8 lg:py-32" data-id="element-32" data-mp="318ejd1qyic4o">
        <div data-id="element-33" data-mp="3sxhp6lyhrujf">
          <p className="text-sm font-medium text-gold-deep" data-id="element-34" data-mp="3sxzjhd1lfyop">Contacto</p>
          <h2 className="mt-3 text-3xl font-semibold tracking-tight sm:text-4xl" data-id="element-35" data-mp="3ow4hs7fr3jae">Agendá una consulta con Fortis</h2>
          <p className="mt-5 max-w-md text-lg leading-relaxed text-ink/75" data-id="element-36" data-mp="3k4w95dm8w1ya">
            Contanos tu situación y te orientamos sobre los próximos pasos de tu carrera, sin compromiso.
          </p>

          <ul className="mt-12 space-y-6" data-id="element-37" data-mp="gg2sabsf3mnf">
            <li data-id="element-38" data-mp="ghvvti7qhqr7">
              <a href={contactInfo.whatsappUrl} target="_blank" rel="noopener noreferrer" className="group flex items-center gap-4" data-id="element-39" data-mp="giffb3d18n7c">
                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-ink text-gold" data-id="element-40" data-mp="3jxxh8tug50xe">
                  <MessageCircleIcon className="h-5 w-5" aria-hidden="true" data-id="element-41" data-mp="3b39aez983b6h" />
                </span>
                <span data-id="element-42" data-mp="3f4uscz0m6fnj">
                  <span className="block text-sm text-ink/60" data-id="element-43" data-mp="3f42zvx2bcy1h">WhatsApp</span>
                  <span className="block text-lg font-medium transition-colors duration-150 ease-out group-hover:text-gold-deep" data-id="element-44" data-mp="315d18czuiqb0">
                    {contactInfo.whatsappDisplay}
                  </span>
                </span>
              </a>
            </li>
            <li data-id="element-45" data-mp="2s684nc7uh71h">
              <a href={`mailto:${contactInfo.email}`} className="group flex items-center gap-4" data-id="element-46" data-mp="2s6rmksxhvvfi">
                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-ink text-gold" data-id="element-47" data-mp="2w7tojhisqll6">
                  <MailIcon className="h-5 w-5" aria-hidden="true" data-id="element-48" data-mp="uenclc2azrgl" />
                </span>
                <span data-id="element-49" data-mp="ucay58vr7z8a">
                  <span className="block text-sm text-ink/60" data-id="element-50" data-mp="23bc5j9lies25">Correo</span>
                  <span className="block text-lg font-medium transition-colors duration-150 ease-out group-hover:text-gold-deep" data-id="element-51" data-mp="2397pxue904m1">
                    {contactInfo.email}
                  </span>
                </span>
              </a>
            </li>
          </ul>
        </div>

        <ContactForm data-id="element-52" data-mp="1pdnibv3yz8tx" />
      </div>
    </section>;
}